import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getApiUrl, API_ENDPOINTS } from "../../config/apiConfig";
import { AuthContext } from "../../context/AuthContext";

const Login = () => {
  const [userCode, setUserCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!userCode || !password) {
      setError("Please enter both user code and password.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(getApiUrl(API_ENDPOINTS.login), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userCode: userCode,
          password: password,
        }),
      });

      const data = await response.json();

      if (response.ok && data.status === 200 && data.appuser) {
        setError("");
        
        // Extract user data from appuser object
        const userData = {
          id: data.appuser.id,
          code: data.appuser.code,
          name: data.appuser.name,
          email: data.appuser.email,
          mobile: data.appuser.mobile,
          userType: data.appuser.userType,
          isActive: data.appuser.isActive,
        };
        
        // Use AuthContext login
        login(userData, data.token);
        
        // Redirect to dashboard without alert (cleaner UX)
        navigate("/dashboard");
      } else {
        setError(data.message || "Invalid user code or password.");
      }
    } catch (err) {
      setError("Network error. Please try again later.");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container py-5" style={{ maxWidth: "420px" }}>
      <h2 className="text-center fw-bold mb-4">Login</h2>

      <div className="card shadow-sm">
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="userCode" className="form-label">
                User Code
              </label>
              <input
                id="userCode"
                type="text"
                className="form-control"
                value={userCode}
                onChange={(e) => setUserCode(e.target.value)}
                placeholder="Enter your user code"
                required
                disabled={loading}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;
